import React, { forwardRef, useState } from 'react'
import { FormControl, Input, InputLabel, InputProps } from '@mui/material'

import StripeInput from './StripeInput'

export interface StripeElementWrapperProps extends InputProps {
  readonly component: React.JSXElementConstructor<any>
  readonly label: React.ReactNode
}

const StripeElementWrapper = forwardRef<
HTMLDivElement,
StripeElementWrapperProps
>(function StripeElementWrapper({ component, label, onChange, ...rest }, ref) {
  const [focused, setFocused] = useState(false)
  const [empty, setEmpty] = useState(true)
  const [error, setError] = useState(false)

  const handleBlur = () => {
    setFocused(false)
  }

  const handleFocus = () => {
    setFocused(true)
  }

  const handleChange = (changeObj: any) => {
    setError(changeObj.error)
    setEmpty(changeObj.empty)
    if (onChange) {
      onChange(changeObj)
    }
  }

  return (
    <FormControl fullWidth margin="normal" ref={ref}>
      <InputLabel
        error={Boolean(error)}
        focused={focused}
        shrink={focused || !empty}
      >
        {label}
      </InputLabel>
      <Input
        fullWidth
        inputComponent={StripeInput}
        inputProps={{ component }}
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={handleFocus}
        {...rest}
      />
    </FormControl>
  )
})

export default StripeElementWrapper
